import "../styles/buyBox.scss";
import VariantenwechselLogic, { VariantenWechselDetails, variantenWechselEvent } from "./VariantenwechselLogic";
import * as CubeTrackingAB from "./tracking/cube/AbTestTracking";
import * as GtmTrackingAB from "./tracking/gtm/AbTestTracking";

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface DocumentEventMap {
        [variantenWechselEvent]: CustomEvent<VariantenWechselDetails>;
    }
}

class BuyBox extends HTMLElement {
    private readonly buyBoxLogic: VariantenwechselLogic;
    private observer: IntersectionObserver;
    private alreadyTracked: boolean;
    private variantenWechselEventAbortController: AbortController;

    constructor() {
        super();
        this.buyBoxLogic = new VariantenwechselLogic(this.replaceBuyBoxContent.bind(this), fetch);
        this.observer = new IntersectionObserver(this.handleObservationEvent.bind(this), { threshold: 0.9 });
        this.variantenWechselEventAbortController = new AbortController();
        this.alreadyTracked = false;
    }

    connectedCallback(): void {
        const pathPrefix = this.getAttribute("data-path-prefix");
        const ajaxPath = this.getAttribute("data-ajax-path");
        if (pathPrefix && ajaxPath) {
            this.buyBoxLogic.setPathPrefix(pathPrefix);
            this.buyBoxLogic.setAjaxPath(ajaxPath);
            document.addEventListener(variantenWechselEvent, this.handleVariantenWechsel.bind(this), {
                passive: true,
                signal: this.variantenWechselEventAbortController.signal,
            });
        }

        this.observer.observe(this);
    }

    private replaceBuyBoxContent(content: string): void {
        this.observer.unobserve(this);
        this.alreadyTracked = false;
        this.innerHTML = content;
        this.observer.observe(this);
    }

    private handleVariantenWechsel(event: CustomEvent<VariantenWechselDetails>): void {
        void this.buyBoxLogic.handleEvent(event);
    }

    private handleObservationEvent(entries: IntersectionObserverEntry[]): void {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !this.alreadyTracked) {
                const el = this.querySelector<HTMLDivElement>('[data-select="buybox-content"]');
                const abTestHeaderName = el?.getAttribute("data-abtest-name");
                const abTestHeaderValue = el?.getAttribute("data-abtest-value");
                CubeTrackingAB.trackView(abTestHeaderValue, abTestHeaderName);
                GtmTrackingAB.trackView(abTestHeaderValue, abTestHeaderName);
                this.alreadyTracked = true;
            }
        });
    }

    disconnectedCallback(): void {
        this.observer.disconnect();
        this.variantenWechselEventAbortController.abort();
    }
}

customElements.define("entd-buybox", BuyBox);
